// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1oN5o","large":"styles_large__hKwpd"};